<template>
  <div class="home">
    <v-container v-if="vendors.length > 0" fluid>
      <v-row dense>
        <v-col v-for="vendor in vendors" :key="vendor.id" :cols="cardDimensions.flex">
          <v-card hover ripple :to="{ name: 'branches', params: { username: vendor.username } }">
            <v-img
              v-if="vendor.logo"
              :src="vendor.logo"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              :height="cardDimensions.imgHeight"
            ></v-img>

            <div class="d-flex justify-center py-2 grey lighten-4" v-else>
              <v-avatar size="60px" color="primary darken-4">
                <v-icon x-large dark>mdi-store</v-icon>
              </v-avatar>
            </div>

            <v-card-title
              class="d-block text-truncate text-center font-weight-bold text-subtitle-2 py-3"
              v-text="vendor.name"
            ></v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card depressed class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-btn depressed class="primary darken-4 text-none" :to="{name: 'register'}">
                <v-icon left>mdi-store</v-icon>
                <span class="text-none">Register as a Vendor</span>
              </v-btn>
            </div>

            <div class="text-center mt-2 text-body-2 grey--text">Be the first public vendor</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import { login } from "@/helpers/auth";

export default {
  name: "Home",
  data: () => ({
    isLoading: false
  }),

  methods: {
    async getVendors() {
      await this.$store.dispatch("getVendors");
    }
  },

  mounted() {
    this.getVendors();
  },

  computed: {
    cardDimensions() {
      const nameType = this.$vuetify.breakpoint.name;
      var value = 0;

      switch (nameType) {
        case "xs":
          value = { flex: 6, imgHeight: "108px" };
          break;
        case "sm":
        case "md":
          value = { flex: 4, imgHeight: "200px" };
          break;
        case "lg":
        case "xl":
          value = { flex: 3, imgHeight: "200px" };
          break;

        default:
          value = { flex: 3, imgHeight: "200px" };
      }

      return value;
    },

    vendors() {
      return this.$store.state.vendors.vendors;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    }
  }
};
</script>

<style>
</style>
